import React from 'react';
import Navigation from '../components/Navigation';
import UserProfile from '../components/UserProfile';
import './Profile.css';

const Profile = () => {
  return (
    <div>
      <Navigation />
      <div className="content">
      <UserProfile />
      </div>
    </div>
  );
};

export default Profile;
